export default "__VITE_ASSET__BPgS5OAP__"